<template>
<div class="chapter">
<div class="inner_page">
<p class="image1"><img alt="image" src="images/line.png"/></p>
<h2 class="h2a">PART ONE</h2>
<p class="image"><img alt="image" src="images/line.png"/></p>
<p class="h2b"><em>Growing Up in the<br/>Country of Show<br/>Business</em></p>
<p class="indent"><a id="page_1"></a></p><a id="page_1">
</a><p class="indent"><a id="page_1"></a><a id="page_2"></a></p><a id="page_2">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005.vue?99f98b68